import RefreshIcon from '@assets/buttons-icons/refresh.svg?react';
import { QuickActionProps } from '@components/suggestions/quickActions/types';
import Editor from '@lib/core/src/components/Editor';
import { InputText } from '@lib/core/src/components/Inputs';
import palette from '@lib/core/src/theme/palette';
import { IconButton, CircularProgress, InputLabel } from '@mui/material';

import { Row } from './AgentStyle';
import AgentWrapper from './AgentWrapper';
import QuickActionAnimationWrapper from './QuickActionAnimationWrapper';
import { EditorWrapper, InputContainer } from './QuickActionStyle';
import useTaskFollowUpQuickActionLogic from './hooks/useTaskFollowUpQuickActionLogic';

const agentText = {
  title: 'Found this task on ',
  text: 'Do you want me to follow up with '
};

const TaskFollowUpQuickAction = ({
  quickAction,
  index,
  firstQuickActionControls,
  secondQuickActionControls
}: QuickActionProps) => {
  const {
    emailMessageObject,
    emailSubject,
    emailMessage,
    emailMessageLoading,
    isGenerateDelegateFollowUpMessagePending,
    setEmailMessage,
    setEmailSubject,
    reGenerateMessage,
    emailBody,
    bubbleTextUsers
  } = useTaskFollowUpQuickActionLogic({
    quickAction,
    index
  });

  return (
    <QuickActionAnimationWrapper
      quickActionId={quickAction.id!}
      index={index}
      firstQuickActionControls={firstQuickActionControls}
      secondQuickActionControls={secondQuickActionControls}
    >
      <AgentWrapper
        title={agentText.title}
        titleUnderlined={emailMessageObject?.subject || ''}
        bubbleText={`${agentText.text} ${bubbleTextUsers}`}
        emailBodyHtml={emailBody}
      ></AgentWrapper>
      {emailMessageLoading || isGenerateDelegateFollowUpMessagePending ? (
        <CircularProgress sx={{ margin: 'auto' }} />
      ) : (
        <>
          <Row>
            <InputContainer>
              <InputLabel sx={{ fontSize: '11px', fontWeight: '500', color: palette.grey[500] }}>
                Subject
              </InputLabel>
              <InputText
                value={emailSubject}
                onChange={e => setEmailSubject(e.target.value)}
                type="text"
                placeholder="Subject"
              />
            </InputContainer>
          </Row>
          <>
            <div style={{ fontSize: '11px', fontWeight: '500', color: palette.grey[500] }}>
              Message
            </div>
            <EditorWrapper>
              <IconButton
                sx={{ position: 'absolute', top: '3px', right: '0px' }}
                onClick={reGenerateMessage}
              >
                <RefreshIcon />
              </IconButton>
              <Editor value={emailMessage} onChange={setEmailMessage} minHeight="280px" />
            </EditorWrapper>
          </>
        </>
      )}
    </QuickActionAnimationWrapper>
  );
};

export default TaskFollowUpQuickAction;
